import { MSelect } from '@Components/Base';
import { Col, Form, Row } from 'antd';
import { FormikProps } from 'formik';
import { Option, OptionNum } from '@Components/types/options';
import { useEffect } from 'react';

interface SelectProps<T> {
  formik: FormikProps<T>;
  options: Option[] | OptionNum[];
  formikKey: string;
  label?: string;
  placeholder?: string;
  loading?: boolean;
  disabled?: boolean;
}

const Select = <T,>({
  formik,
  options,
  formikKey,
  label,
  placeholder,
  loading,
  disabled,
}: SelectProps<T>): JSX.Element => {
  const formikValue = formik.getFieldMeta(formikKey).value; // Get the current value from formik

  // Clear value when there are no options
  useEffect(() => {
    if (options.length === 0 && formikValue) {
      formik.setFieldValue(formikKey, '');
    }
  }, [options, formikValue, formikKey, formik]);

  return (
    <Row>
      <Col span={24}>
        <Form.Item>
          <MSelect
            labeloption={label}
            options={options}
            value={options.length === 0 ? undefined : formikValue} // Don't show value when no options
            onChange={(value) => {
              formik.setFieldValue(formikKey, value);
            }}
            placeholder={placeholder}
            loading={loading}
            disabled={disabled}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default Select;
